<template lang="pug">
  modal(:title='$t(`krea.kreaFileUploader.${modalProps.type}.header`)' @closeModal='closeModal')
    krea-file-uploader.m-top-2(
      :forModal='true'
      :type='modalProps.type'
      :link='modalProps.link'
      :linkType='modalProps.linkType'
      :updateLink='updateLink'
      :updateFile='updateFile'
      @close='closeModal'
    )
</template>

<script>
import Modal from '@/components/Modal'
import KreaFileUploader from '@/components/Krea/Inputs/KreaFileUploader'
import { mapActions, mapState } from 'vuex'

export default {
  components: { Modal, KreaFileUploader },
  computed: {
    ...mapState({
      modalProps: state => state.behavior.kreaFileUploaderModal.props
    })
  },
  methods: {
    ...mapActions([
      'hideElement',
      'showElement'
    ]),
    updateLink(value) {
      this.modalProps.updateLink(value)
      this.closeModal()
      this.showElement({
        element: 'resizeImageModal',
        props: { imgSrc: value }
      })
    },
    updateFile(value) {
      this.modalProps.updateFile(value)
      this.closeModal()
      this.showElement({
        element: 'resizeImageModal',
        props: { imgSrc: value }
      })
    },
    closeModal() {
      this.hideElement({ element: 'kreaFileUploaderModal' })
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
